import dayjs, {formatLocaleDate} from '@/dayjs'
import {StyledDateRangeMonthRadioGroup, StyledDateRangeMonthRadioItem} from './style'
import {capitalize} from '@/utilities/helpers'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'

interface DateRangeMonthSelectorProps {
    selectedMonth: number
    onMonthChange: (month: number) => void
    isAllYearSelected?: boolean
    disabledMonths?: number[]
}

// Generate months dynamically using dayjs
const generateMonths = () => {
    return Array.from({length: 12}, (_, index) => ({
        label: capitalize(formatLocaleDate(dayjs().month(index).toDate(), 'MMMM')),
        value: index
    }))
}

export const DateRangeMonthSelector = ({
    selectedMonth,
    onMonthChange,
    isAllYearSelected,
    disabledMonths
}: DateRangeMonthSelectorProps) => {
    const months = generateMonths()

    const handleMonthSelect = (value: string) => {
        if (value) {
            onMonthChange(parseInt(value, 10))
        }
    }

    return (
        <StyledDateRangeMonthRadioGroup
            type="single"
            value={selectedMonth.toString()}
            onValueChange={handleMonthSelect}
        >
            <Grid columns={3} gap={3} fullWidth>
                {months.map(month => {
                    const isDisabled = !!isAllYearSelected || !!disabledMonths?.includes(month.value)
                    return (
                        <StyledDateRangeMonthRadioItem
                            key={month.value}
                            value={month.value.toString()}
                            $isSelected={selectedMonth === month.value || !!isAllYearSelected}
                            $isDisabled={isDisabled}
                            disabled={!isAllYearSelected && !!disabledMonths?.includes(month.value)}
                        >
                            {month.label}
                        </StyledDateRangeMonthRadioItem>
                    )
                })}
            </Grid>
        </StyledDateRangeMonthRadioGroup>
    )
}
